const trainingOption1Bundle = [
  {
    link: "https://sixzerosixacademy.playbookapi.com/programs/more_info/class_package/65069/",
    name: "November 21st Tournament",
    date: "Click to Learn More",
  },
]


const trainingInfo = [
  "Deadline to register is November 7th",
  "Come have fun!",
  "$100 per team",
  "Winners will get medals and bragging rights",
  "3 Game Guarantee",
  "Minumum 6 teams, max 12 teams",
  "Games to 11 win by 2",
  "Snacks and water will be provided",
  "Bring your own paddle, pickleballs, water bottle, gym shoes, and good vibes (indoor balls recommended)",
]


export {trainingInfo, trainingOption1Bundle}